import { User } from '@capacitor-firebase/authentication';
import { createContext } from 'react';

export interface AuthContextType {
  isLoading: boolean;
  firebaseUser: User | null;
  accessToken: string | null;
  canCaptureLocally: boolean;
  canReplay: boolean;
  logOut: (isLocalOnly?: boolean, inactivityTrigger?: boolean) => Promise<void>;
  /** Stable reference — safe for use in effects/interceptors. For reactive rendering use `accessToken`. */
  getAccessToken: () => string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
